import { render, staticRenderFns } from "./monitoring_objectivesPagination.vue?vue&type=template&id=299d75e0&"
import script from "./monitoring_objectivesPagination.vue?vue&type=script&lang=js&"
export * from "./monitoring_objectivesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports